// collapsible-accessories.js (Final Version based on User's excellent suggestion)

(function() {
    // 定义我们需要的关键元素的选择器
    const sectionSelector = '.ppcse-card-lt-cont';
    const titleSelector = '.ppcse-title';

    // --- 步骤 1: 设置一个永久的、全局的点击监听器 ---
    // 这个监听器只负责切换 class，不触碰任何 style 属性。
    document.body.addEventListener('click', function(event) {
        const clickedTitle = event.target.closest(titleSelector);
        if (!clickedTitle) {
            return; // 如果点击的不是标题，则什么也不做
        }

        const sectionElement = clickedTitle.closest(sectionSelector);
        if (sectionElement) {
            // 这就是JS的全部工作：切换状态！
            sectionElement.classList.toggle('is-collapsed');
        }
    });
    

    // --- 步骤 2: 使用 MutationObserver 来设置初始折叠状态 ---
    // 这个观察者的唯一任务是在元素首次出现时，为其添加 is-collapsed class。
    const observer = new MutationObserver((mutations, obs) => {
        const sectionElement = document.querySelector(sectionSelector);
        if (sectionElement) {
            // 防止重复执行
            if (!sectionElement.classList.contains('is-collapsed')) {
                 sectionElement.classList.add('is-collapsed');
            }
            
            // 任务完成，停止观察
            obs.disconnect();
        }
    });

    // 开始观察，等待元素出现
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    

})();